import { Component, OnInit, EventEmitter, ViewChild, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable, Subject, of } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { DocumentModel, Document_Upload, Document_Upload_File } from 'src/app/models/common';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { DatePipe } from '@angular/common';
import { CommonService } from 'src/app/services/common.service';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';
import * as $ from 'jquery';
import { serviceConstants } from 'src/app/constants/service.constants';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HeadService } from 'src/app/services/common/headservice';

@Component({
  selector: 'app-grants-document-upload-sponsorship',
  templateUrl: './grants-document-upload-sponsorship.component.html',
  styleUrls: ['./grants-document-upload-sponsorship.component.scss']
})
export class GrantsDocumentUploadSponsorshipComponent implements OnInit {

  formFields;
  uploadedFiles = ["Attachement one", "Attachment two", "Attachment three"];
  // File upload
  formData: FormData;
  files: any[];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  permission: string;
  docuemntUploadForm = new UntypedFormGroup({});
  document_attach_list: Document_Upload[] = [];
  @Input() rowid: string = "";
   ScreenMode: string = "";
  applicationID: any;
  now = new Date();
  isUploadValid: boolean = true;
  public validationMessage: string = "";
  FeatureID: string = "079437C409B6A503E0638C00000A789D";
  IsUptoDateList=[];
  action: Subject<any> = new Subject();
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  GrantsUploadFiles: Document_Upload_File[];
  ProfileUptoDateValue : any;
  appid: string;
  operations: any = [];
  staticformFields:any;
  _TransactionID :string;
  constructor(
    private summaryService: GrantsSummaryService,
    public datepipe: DatePipe,
    public commonService: CommonService,
    public datashare: GrantsDatashareService,
    private router: Router,
    private modalService: NgbModal,
    private header: HeadService,
    public grantsDatashare: GrantsDatashareService
  ) {
    this.files = [];
    this.uploadInput = new EventEmitter<any>();
  }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode,this.applicationID)
      .subscribe(summary => {
        this.staticformFields = summary["Data"]; 
        this.IsUptoDateList=this.staticformFields["IS_UPTO_DATE"].GROUP_VALUES_LIST;  
      });
  }

  ngOnInit() {
    this.NavigateToGenInfo();
    this.applicationID = this.commonService.appId;
    this.getStaticFiledsData('SCR-034');

    // var grantapp = this.commonService.getGrantsApp();// "8b3a39fb-99ee-44ce-8c03-c5417eb040d2";
    // this.appid = grantapp.ID;
    this.applicationID=this.appid;
    if (this.rowid == "" || this.rowid == null || this.rowid == undefined)
      this.rowid = "0";
    if (this.applicationID == "" || this.applicationID == null || this.applicationID == undefined) {
      this.applicationID = "0";
    }
    this.docuemntUploadForm = new UntypedFormGroup({
      ID: new UntypedFormControl(null),
      APPLICATION_ID: new UntypedFormControl(null),
      IS_UPTO_DATE: new UntypedFormControl("", [Validators.required]),
      IS_UPTO_DATENo: new UntypedFormControl("", [Validators.required]),

    });

    setTimeout(() => { 
      this.setFormPermissions();
    }, 300);
    this.getFeatureDocuments();
    this.FetchProfileUptodate();

  }

  ngOnChanges() {

    if (this.rowid == "" || this.rowid == null || this.rowid == undefined)
      this.rowid = "0";
    if (this.applicationID == "" || this.applicationID == null || this.applicationID == undefined) {
      this.applicationID = "0";
    }
    this.getFeatureDocuments();
  }

  getFeatureDocuments() {
    let model = new DocumentModel();
    model.Featureid = this.FeatureID;
    model.Rowid = this.rowid;
    model.Appid = this.applicationID;
    this.summaryService.getFeatureDocuments(model).subscribe(summary => {
      this.document_attach_list = summary;
      this._TransactionID = this.document_attach_list[0].TRANSACTION_ID;
    });
  }

  private setFormPermissions() {     
    this.ScreenMode=this.permission = this.commonService.getPagePermission("GSP04");
    if (this.permission == "view") {
      if (this.extendedForm != null && this.extendedForm != undefined) {
        this.extendedForm.permission = this.permission;
        this.extendedForm.ScreenMode = this.permission;
      }
      this.docuemntUploadForm.disable();
    }   
   
  if (this.permission == "view") {
    this.docuemntUploadForm.disable();
    this.operations = [];
  }
  else {
    this.operations = [
      {
        name: 'saveDocumentUploads', type: 'submit', callback: this.saveDocumentUploads, self: this
      }
    ];
  }
  }
  

  FetchProfileUptodate() {
    this.summaryService.FetchProfileUptoDate(this.applicationID).subscribe(response => {
      if(response.Data.IS_PROFILE_UPTO_DATE!=null){
      this.docuemntUploadForm.controls['IS_UPTO_DATE'].setValue(response.Data.IS_PROFILE_UPTO_DATE);
      this.ProfileUptoDateValue = response.Data.IS_PROFILE_UPTO_DATE;
      }
      this.extendedForm.rowid = response.Data.ID;
      this.extendedForm.getResponse();
    })
  }

  uploadchange(event, ques: Document_Upload): void {
    let Flag = true;
    let hasMultipleFiles = false;
    let Duplicate_File_List = [];

    if (ques.UploadFiles == undefined || ques.UploadFiles == null)
      ques.UploadFiles = [];
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      var file = event.target.files[i].name;
      var ext = file.match(/\.([^\.]+)$/)[1];
      var filesize = event.target.files[i].size;

      if (file != null && ((filesize > 15728640) || (ext != 'docx' && ext != 'doc' && ext != 'ppt' && ext != 'pptx' && ext != 'xls' && ext != 'xlsx' && ext != 'txt' && ext != 'pdf'))) {
        Flag = false;
        //this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 15MB"); 
      }
      else {
        let uploadFile = new Document_Upload_File();
        uploadFile.ID = this.commonService.getUniqueId();
        uploadFile.DOCUMENT_NAME = event.target.files[i].name;
        uploadFile.File = event.target.files[i];
        uploadFile.Status = "Add";
        uploadFile.UploadedDate = this.datepipe.transform(this.now.toUTCString(), 'dd-MMM-YYYY');
        uploadFile.Document_Url = "";
        uploadFile.FIELD_ID = "";

        //if(uploadFile.DOCUMENT_NAME)


        uploadFile.SEQUENCE_NO = 0;
        // uploadFile.TRANSACTION_ID = this.applicationID;
        let hasValue = ques.UploadFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase() && x.Status != "Delete");
        if (hasValue.length > 0) {
          hasMultipleFiles = true;
          Duplicate_File_List.push(uploadFile.DOCUMENT_NAME);
        } else {
          if (ques.IsMultipleDocuments) {
            ques.ApplicationID = this.applicationID;
            ques.DOCUMENT_TYPE_ID = ques.DocumentTypeID;
            ques.SEQUENCE_NO = 0;
            ques.UploadFiles.push(uploadFile);
          } else {
            ques.UploadFiles = [];
            ques.UploadFiles.push(uploadFile);
          }
        }
      }
    }
    if (!Flag){
      this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 15MB");
    }
    
      if(hasMultipleFiles){
        this.commonService.ValidationBanner("File already exists with " + Duplicate_File_List.join(', ') + ". Please update the unique file name");
      }
  
  }

  validateControls() {

    this.isUploadValid = true;
    this.validationMessage = "";
    for (let i = 0; i < this.document_attach_list.length; i++) {
      var filelist = this.document_attach_list[i].UploadFiles.filter(function (obj) {
        return obj.Status == "Add" || obj.Status == "Edit";
      });
      if (this.document_attach_list[i].IsManadatory && this.document_attach_list[i].IsDisplay) {
        if (filelist.length == 0) {
          this.isUploadValid = false;
          this.validationMessage += 'Please upload ' + this.document_attach_list[i].LabelName + '<br/>'
        }
      }
    }

    if (this.applicationID == null || this.applicationID == undefined || this.applicationID == "") {
      this.validationMessage += "Please save the general information first.<br/>";
      this.commonService.ValidationBanner(this.validationMessage);
      return false;
    }

    var formData = this.docuemntUploadForm.value;
    var isupdateyes = formData["IS_UPTO_DATE"];
    var isupdateno = formData["IS_UPTO_DATENo"];

    if(this.staticformFields["IS_UPTO_DATE"].IS_Display && this.staticformFields["IS_UPTO_DATE"].IS_MANDATORY){
      if ((isupdateyes === null || isupdateyes === "" || isupdateyes === undefined) && (isupdateno === null || isupdateno === "" || isupdateno === undefined)) {
        $("#IS_UPTO_DATE").addClass("ng-touched ng-invalid validate-error");
        $("#IS_UPTO_DATE").removeClass("ng-untouched ng-valid");
        this.validationMessage += `Please select ${this.staticformFields?.IS_UPTO_DATE.LABEL_NAME} <br/>`;
  
        this.isUploadValid = false;
      }
      else {
        $("#IS_UPTO_DATE").addClass("ng-untouched ng-valid");
        $("#IS_UPTO_DATE").removeClass("ng-touched ng-invalid validate-error");
      }
    }
    
    let ExtenMsgs = this.extendedForm.validateControlsMsgs();
    if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
      this.isUploadValid = false;
      this.validationMessage =  this.validationMessage + ExtenMsgs;
    }
    return this.isUploadValid;
  }


  public saveDocumentUploads() {

    if (this.validateControls()) {
      let response: any;
      var data = this.document_attach_list.filter((item) => {
        return item.IsDisplay == true
      })[0];
      // if (data != undefined && data != null) {
        let formData = new FormData();
        if (this.document_attach_list != null && this.document_attach_list.length > 0) {
         
          for (let i = 0; i < this.document_attach_list.length; i++) {
            this.document_attach_list[i].ApplicationID = this.applicationID;
            // this.document_attach_list[i].TRANSACTION_ID = this.applicationID;
            if (this.document_attach_list[i].UploadFiles != undefined || this.document_attach_list[i].UploadFiles != null) {
              for (let j = 0; j < this.document_attach_list[i].UploadFiles.length; j++) {
                if (this.document_attach_list[i].UploadFiles[j].Status == "Add") {
                  formData.append(this.document_attach_list[i].UploadFiles[j].ID, this.document_attach_list[i].UploadFiles[j].File);
                }
              }
            }
          }
        }
      this.document_attach_list[0].IS_UPTO_DATE = this.ProfileUptoDateValue;
      formData.append("documentattach", JSON.stringify(this.document_attach_list));
      this.summaryService.saveGRTUploadDocDocuments(formData).subscribe(responses => {
        if (responses.Status === 0 || responses.ErrorCode === "NOCHANGES") {
          this.extendedForm.saveControls(responses.Data.TransactionID, this.appid, responses.TransactionCode).subscribe(result => {
            if (result.ErrorCode === "NOCONTROLS") {
              if (responses.Status === 0) {
                this.commonService.SuccessBanner("Document Uploads saved successfully");
                this.getFeatureDocuments();
              }
              else {
                this.commonService.ValidationBanner(responses.Message);
              }
            }
            else {
                if (responses.ErrorCode === "NOCHANGES" && result.ErrorCode === "NOCHANGES") {
                  this.commonService.ValidationBanner(responses.Message);
                } else {
                  this.commonService.SuccessBanner("Document Uploads saved successfully");
                
            }
          }
          this.getFeatureDocuments();
        });
      }else {
        this.commonService.ValidationBanner(responses.Message);
        this.getFeatureDocuments();
      }
      });

    }
    else{
      this.commonService.ValidationBanner(this.validationMessage);
     // this.getFeatureDocuments();
    }
  }

  _upLoadFiles: any;
  DeleteUpload(file, listindex, index): void {

    file.Status = "Delete";
    this.commonService.CheckIsFileIsRefereancedInReviw(file.ID).subscribe((x)=>{
      if(x["Status"]==2 && x["Data"]==false)
      {
        this.commonService.ValidationBanner(x["Message"]);
      }
      else{
        this.document_attach_list.forEach((ele, index) => {
          if (ele.UploadFiles[listindex][index].ID == file.ID) {
            this._upLoadFiles = ele.UploadFiles[listindex];
            this._upLoadFiles.splice(index, 1);
          }
        })
      }
    });
   
  }

  OnNotesOuts(notesvalue, index) {
    this.document_attach_list.forEach((ele, node) => {
      if (node == index) {
        ele.NOTES = notesvalue;
      }
    })
  }

  DownloadFile(fileID) {
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }

  profileUptodateClick(value) {
    this.document_attach_list[0].IS_UPTO_DATE = value;
    this.ProfileUptoDateValue = value;
  }

  NavigateToGenInfo(){
      this.appid = this.commonService.appId;
      let ModuleMenu=this.commonService.getModuleMenu();
      if (this.appid == null || this.appid == undefined || this.appid == "") {
        const modalRefBud2 = this.modalService.open(MessageBoxComponent, {});
        modalRefBud2.componentInstance.Content = { heading: '', content: { heading: '', description: 'Please save General information details to navigate to Document Uploads', operation: { hasConfirm: false } } };
        modalRefBud2.result.then((result) => {
          this.router.navigate(['/home/grants/my-applications/application-ext/:' + this.appid + '/genInformsponsorship'],
            { skipLocationChange: true, queryParams: { id: this.appid, app_ext: true, module: "grants",submodule:ModuleMenu.module, screen_type: "my-applications" } })
        });
        return false;
      }
  }
  

}
